<template>
  <div class="combo-detail">
    <Navbar title="订单详情"></Navbar>
    <div class="content">
      <!-- 套餐内容 -->
      <div class="combo">
        <van-cell-group>
          <van-cell
            :title="item.itemName"
            :value="item.quantity + item.unit"
            v-for="(item, index) in comboDetail.serviceItems"
            :key="index"
          />
        </van-cell-group>
        <div class="rules">
          <div class="title">活动规则</div>
          <div class="rules-content">
            {{ comboDetail.promotionRule }}
          </div>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="combo-info">
        <div>开通时间：{{ comboDetail.createAt }}</div>
        <div>过期时间：{{ comboDetail.validTime }}</div>
        <div>车主手机：{{ comboDetail.userPhone }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { comboDetail } from "@/api/combo";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      comboDetail: {}
    };
  },
  mounted() {
    this.handleComboDetail(this.$route.query.id);
  },
  methods: {
    // 套餐详情
    handleComboDetail(id) {
      comboDetail(id).then(res => {
        // console.log("套餐详情:", res);
        this.comboDetail = res;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.combo-detail {
  .content {
    padding: 10px 15px;

    .combo {
      margin-bottom: 20px;
      background-color: #f6f7f9;
      border-radius: 10px;

      .rules {
        padding: 20px 10px;

        .title {
          margin-bottom: 10px;
          text-align: left;
        }

        .rules-content {
          white-space: pre-line;
          text-align: left;
          font-size: 14px;
          color: #7e7e7e;
        }
      }
    }

    .combo-info {
      padding: 10px;
      background-color: #f6f7f9;
      border-radius: 10px;
      text-align: left;
      color: #7e7e7e;

      div {
        margin-bottom: 10px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.combo-detail {
  .content {
    .combo {
      .van-cell {
        padding: 10px 10px;
        background-color: #f6f7f9;
        font-size: 16px;

        .van-cell__title {
          text-align: left;
        }
      }
    }
  }
}
</style>
